import { defineStore } from 'pinia';
import { AxiosRequestConfig } from "axios";
import getCsrfTokenFromCookie from "@/util/csrf-token";
import handleTeacherError from "@/util/handle_teacher_error";
import apiRequest from '@/util/api-request';


export const useEntryFormStore = defineStore('teacherEntryFormStore', {
  // actions
  actions: {
    async fetchLatestAcademicSessions() {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/entry/latest_academic_sessions/",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const AcademicSessionsResult = await apiRequest(config);
        return AcademicSessionsResult.data.academic_sessions
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchTextbookPublishers() {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/entry/textbook_publishers/",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const TextbookPublishersResult = await apiRequest(config);
        return TextbookPublishersResult.data.subject_fields_textbook_publishers
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchSchools(schoolTypeCode: number) {
      try {
        const config: AxiosRequestConfig = {
        method: "get",
        url: `/teacher/api/entry/schools/?school_type_code=${schoolTypeCode}`,
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCsrfTokenFromCookie(document.cookie)
        }
        };
        const SchoolsResult = await apiRequest(config);
        return SchoolsResult.data.schools
      } catch (e) {
          handleTeacherError(e)
      }
    },
    async fetchEntryAdd(payload) {
      try {
        const config: AxiosRequestConfig = {
        method: "post",
        url: "/teacher/api/entry/add/",
        headers: {
        	"Content-Type": "application/json",
        	"X-CSRFToken": getCsrfTokenFromCookie(document.cookie)
      	},
        data: payload
        };
        const EntryAddResult = await apiRequest(config);
        window.location.href = EntryAddResult.data["redirect_url"];
        return null;
      } catch (e) {
        // 想定されるエラーコードの場合は、エラー情報を返す
        // モーダルが表示されてしまうのでhandleTeacherErrorは使わない
        if (["E01", "E02", "E03", "E04"].includes(e.response.data.error.code)) {
          return {
            code: e.response.data.error.code,
            title: e.response.data.error.message,
            text: e.response.data.error.data?.detail
          };
        };
        // 予期せぬエラーの場合はエラー情報をクリアして固定のメッセージを表示
        e.response.data.error = null;
        handleTeacherError(e)
      }
    },
    async fetchDefaultLicenseCount(school_code: string, license_type: number, school_type_code: number) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: `/teacher/api/entry/default-license-counts/?school_code=${school_code}&license_type=${license_type}&school_type_code=${school_type_code}`,
          headers: {
            "Content-Type": "application/json",
          },
        };
        const defaultLicenseCountResult = await apiRequest(config);
        return defaultLicenseCountResult.data.license_defaults
      } catch (e) {
        handleTeacherError(e)
        return []
      }
    },
  }
});
